import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { MutService } from './mut.service';

@Injectable()
export class MutEmployeeGuard implements CanActivate {

    constructor(
        private mutService: MutService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const employeeId = route.paramMap.get('employeeId');
        return of(this.mutService.checkIfEmployeeExists(Number(employeeId)));
    }
}
